<template>
  <button v-bind="$attrs" type="submit" @click="handleClick" class="btn btn_success btn_small">
    <slot/>
    <icon-base width="16" height="16" viewBox="0 0 512 512" class="btn__icon">
      <icon-save/>
    </icon-base>
  </button>
</template>

<script>
export default {
  name: "SaveBtn",
  methods: {
    // Просто дефолтное поведение, чтоб @click работал на компоненте
    handleClick(evt) {
      this.$emit('click', evt);
    }
  },
}
</script>